export default __webpack_public_path__ + "static/media/Accreditation-6.540bce0c.png";